import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPanoramaView: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="panorama-view"><path d="M22.25 19.25V4.75C15.1797 7.12452 8.82033 7.12452 1.75 4.75V19.25C8.78176 16.8507 15.2182 16.8507 22.25 19.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPanoramaView;
